import React, { useEffect, useState } from "react";
import { Route, Redirect } from 'react-router-dom';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { isTokenValid } from '../Utils/index';
import { getUser } from 'services/actions/Autenticacao/AuthService';
import { useSelector } from 'react-redux';

export default function ProtectedRoute({ component: Component, roles,  ...rest }) {
   const { user } = useSelector((store) => {
      return store.userState;
    });
  const isLoggingOut = sessionStorage.getItem('LOGGING_OUT') === 'true';
  const isAuthenticated = !isLoggingOut && !!user.token && isTokenValid(user.token);
  
  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect to="/login-redirect" />
        )
      }
    />
  );
}


// const useProtectedRoute = ({ component: Component, roles, ...rest }) => {
//   const [authorized, setAuthorized] = useState(false);
//   const history = useHistory();

//   useEffect(() => {
//     let mounted = true;

//     async function checkAuth() {
//       const user = await getUser();

//       if (!user || user.expired || !isTokenValid(user.id_token)) {
//         history.push('/login-redirect');
//         return;
//       }

//       if (mounted) {
//         setAuthorized(true);
//       }
//     }

//     checkAuth();

//     return () => { mounted = false };
//   }, []);

//   return (
//     authorized
//       ? <Route {...rest} component={Component} />
//       : <></>
//   );


  // const token = user?.token || sessionStorage.getItem("ANMToken");
  // useEffect(() => {
  //   if (!token || !isTokenValid(token)) {
  //     handleRedirect(history);
  //   }
  // }, [token, history]);
  // if (!token || !isTokenValid(token)) {
  //   return null;
  // }

  // if (authorized === false) {
  //   history.push("/acesso");
  //   return null;
  // }

  // return <Route {...rest} component={Component} />;
// };

// export default useProtectedRoute;
